"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CaravanTrailerBoxStand = function CaravanTrailerBoxStand(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.2,16.13A1.86,1.86,0,1,0,12.06,18,1.86,1.86,0,0,0,10.2,16.13Zm0,3A1.13,1.13,0,1,1,11.33,18,1.13,1.13,0,0,1,10.2,19.12Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20,17.37s.81-3.72,1-4.54a3.71,3.71,0,0,0,0-1.48l-.88-4.73c-.16-.44-.81-.4-.81-.4s-17.49,0-17.93,0-.49.62-.49.62S.21,10.7.06,11.49a5.7,5.7,0,0,0,.06, 1.84L.89,17.7a.61.61,0,0,0,.62.5H7.84a2.35,2.35,0,1,1,4.67,0H24v-.83ZM8.45,11a.36.36,0,0,1-.36.36H2.76A.36.36,0,0,1,2.4,11V8.49a.36.36,0,0, 1,.36-.36H8.09a.36.36,0,0,1,.36.36ZM18,16.9a.36.36,0,0,1-.36.36H14.42a.36.36,0,0,1-.36-.36V8.49a.36.36,0,0,1,.36-.36h3.21a.36.36,0,0,1,.36.36Z"
  }));
};

var _default = CaravanTrailerBoxStand;
exports["default"] = _default;